import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDIcon,
  FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export const GuidedHouseholdReviewGoalListSuggestion = ({ onDeleted }) => {
  const {
    resource, saving, onDelete,
  } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent({
    nodeName: 'PM1 Goal Suggestions',
  });
  const onDeleteWithNotify = useCallback(async () => {
    await onDelete();
    onDeleted();
    logStandardizedEvent(categories.pm1OrPM2, eventTypes.suggestion, eventSubTypes.dismiss, { eventProperties: { name: resource.attr('name') } });
  }, [onDelete, onDeleted, logStandardizedEvent]);

  return (
    <FDStack direction="row" spacing={2} justifyContent="space-between">
      <FDStack direction="row" spacing={1} alignItems="center">
        <FDIcon
          icon={'sparkles'}
          size={'sm'}
          color={'textPrimary'}
        />
        <MetaControlField attr="name" flex={1} />
      </FDStack>
      <FDStack direction="row" spacing={1} alignItems={'center'}>
        <SecondaryActionButtonRel
          relationship={resource.relationship(fr.relationships.addItem.name)}
          size={'sm'}
          afterSuccessfulOnClick={() => logStandardizedEvent(categories.pm1OrPM2, eventTypes.suggestion, eventSubTypes.select)}
        />
        {resource.meta().canDelete() ? (
          <FDSecondaryActionIconButton
            icon="close"
            label="Dismiss"
            onClick={onDeleteWithNotify}
            loading={saving}
          />
        ) : null}
      </FDStack>
    </FDStack>
  );
};

GuidedHouseholdReviewGoalListSuggestion.propTypes = {
  onDeleted: PropTypes.func.isRequired,
};
